import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];
import { Menu } from '@mui/material';
var AwaitedMenu = function (_ref) {
    var children = _ref.children, others = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ React.createElement(Menu, others, children);
};
export default AwaitedMenu;
